import(/* webpackMode: "eager" */ "/home/clients/ff5a48c1f030f673fbc44b0fd81e7291/web/dev.intento.ch/src/app/global-error.tsx");
